// Load store modules dynamically.
const requireContext = require.context('./filters', true, /.*Filter\.js$/);

const filters = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {

    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    name  = name.substr(0, name.length - 6).toLowerCase();

    return { ...modules, [name]: module.default }
  }, {});

export default filters;